import { CallStats, StatsCommon } from '#common/stats';
export class NetworkStats extends StatsCommon {
    connect;
    disconnect;
    pendingRequests = 0;
    requests = 0;
    retries = 0;
    timeouts = 0;
    constructor(log) {
        super();
        this.connect = new CallStats('connect', log);
        this.disconnect = new CallStats('disconnect', log);
    }
}
